import axios from 'axios'
import {defineStore} from 'pinia'
import {useAuthStore} from "./auth";


export const useDownloadStore = defineStore({
    id: 'download',

    state: () => ({
        selectedItems: [],
    }),
    actions: {
        getEntityDownload(payload) {
            return new Promise((resolve, reject) => {
                axios.defaults.headers['Authorization'] = 'Bearer ' + useAuthStore().bearerToken
                let selectedItems = useDownloadStore().selectedItemsGetters
                if (selectedItems.length > 0) {
                    payload.queryParams['id__in'] = selectedItems
                }
                let url = new URL(axios.defaults.baseURL + 'api/' + payload.entity + '/download/')
                if (payload.queryParams !== null) {
                    let params = new URLSearchParams()
                    for (let i = 0; i < Object.keys(payload.queryParams).length; i++) {
                        params.set(Object.keys(payload.queryParams)[i], Object.values(payload.queryParams)[i])
                    }
                    url.search = params
                    axios.get(url.pathname + url.search)
                        .then(res => {
                            let contentDisposition = res.headers.get('content-disposition').split('filename=')
                            const blob = new Blob([res.data], {type: "text/csv"});
                            const link = document.createElement("a");
                            link.href = URL.createObjectURL(blob);

                            if (!contentDisposition) {
                                link.download =payload.entity + '-export-' + new Date().toISOString() + '.csv';
                            } else {
                                link.download = contentDisposition[1].substring(1, contentDisposition[1].length - 1);
                            }

                            link.click();
                            URL.revokeObjectURL(link.href);
                            resolve(res)
                        })
                        .catch(err => {
                            reject(err)
                        })
                } else {
                    axios.get(url.pathname)
                        .then(res => {
                            const blob = new Blob([res.data], {type: "text/csv"});
                            const link = document.createElement("a");
                            link.href = URL.createObjectURL(blob);
                            link.download = 'export.csv';
                            link.click();
                            URL.revokeObjectURL(link.href);
                            resolve(res)
                        })
                        .catch(err => {
                            reject(err)
                        })
                }

            })
        },

    },

    getters: {
        selectedItemsGetters: state => {
            return state.selectedItems
        }
    }
})


